var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.15 17.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,.72A.32.32,0,0,0,.72,1V16.16a.33.33,0,0,0,.32.32H13.11a.33.33,0,0,0,.32-.32V1a.32.32,0,0,0-.32-.32ZM13.11,17.19H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H13.11a1,1,0,0,1,1,1V16.16a1,1,0,0,1-1,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.43,6.11H6.86V3.42H2.43Zm4.47.72H2.38a.68.68,0,0,1-.67-.68V3.37a.67.67,0,0,1,.67-.67H6.9a.67.67,0,0,1,.68.67V6.15a.68.68,0,0,1-.68.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.08,9.38H2.3A.36.36,0,0,1,1.94,9a.36.36,0,0,1,.36-.36h9.78a.36.36,0,0,1,.36.36.36.36,0,0,1-.36.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.08,11.94H2.3a.36.36,0,1,1,0-.72h9.78a.36.36,0,0,1,0,.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.08,14.5H2.3a.36.36,0,0,1,0-.72h9.78a.36.36,0,0,1,0,.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.08,3.84h-3a.36.36,0,0,1-.36-.36.36.36,0,0,1,.36-.36h3a.36.36,0,0,1,.36.36.36.36,0,0,1-.36.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.08,6.4h-3a.36.36,0,0,1,0-.72h3a.36.36,0,1,1,0,.72"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArticle);
export default __webpack_public_path__ + "static/media/menuArticle.8d0b9971f4dea4f7d8ca6cc25ef15ada.svg";
export { ForwardRef as ReactComponent };